import { combineReducers } from 'redux'
import my from './my/reducers'

const projectsReducer = combineReducers({
  my,
})

export default projectsReducer
